/** Shared hook: load the available rule sets. */
import { useState, useEffect } from 'react';
import { onRules } from '../services/tripleCrown';

/* ── Shared hook: load available rule sets ── */
export default function useRules() {
  const [rules, setRules] = useState([]);
  useEffect(() => onRules(setRules), []);
  return rules;
}
